import api from '@/api'
import {
  SET_ADMINISTRATORNOTICE_LIST,
  SET_HISTORYNOTICE_LIST,
  CHANGE_LOADING_STATE,
  SET_NOTICE_IDS,
} from './mutation-types'

const state = {
  latestNoticeList: [],
  historyNoticeList: [],
  noticeIds: [],
  loading: true,
  type: 0,
}

const mutations = {
  [SET_ADMINISTRATORNOTICE_LIST] (state, payload) {
    state.latestNoticeList = payload
  },
  [SET_HISTORYNOTICE_LIST] (state, payload) {
    state.historyNoticeList = payload
  },
  [SET_NOTICE_IDS] (state, payload) {
    state.noticeIds = payload
  },
  [CHANGE_LOADING_STATE] (state, payload) {
    state.loading = payload
  },
}

const actions = {
  // 获取最新10条管理员公告信息
  async getLatestMessageList ({state, commit}, payload) {
    const type = payload ? payload.type : state.type
    commit(CHANGE_LOADING_STATE, true)
    const {data} = await api.deployApi.latestAdministratorMessage({type: type})
    commit(SET_NOTICE_IDS, data)
    commit(SET_ADMINISTRATORNOTICE_LIST, state.noticeIds)
    commit(CHANGE_LOADING_STATE, false)
  },
  getNewestNotice ({dispatch}, payload) {
    dispatch('getLatestMessageList', payload)
    // .then(() => {
    //   dispatch('getHistoryNoticeList')
    // })
  },
  // 获取历史信息
  async getHistoryNoticeList ({state, commit}, payload) {
    const {bulletinId, type} = payload
    const {data} = await api.deployApi.getAdminBulletinHistory({bulletinId, type: type || state.type})
    return data
    // commit(SET_HISTORYNOTICE_LIST, hasHistory)
    // commit(SET_ADMINISTRATORNOTICE_LIST, state.noticeIds)
    // commit(CHANGE_LOADING_STATE, false)
  },
   // 清空数据
  clearData ({commit}) {
    commit(SET_ADMINISTRATORNOTICE_LIST, [])
  },
  // 新增管理员公告
  async addAdministratorNotice ({state, dispatch}, payload) {
    const {type} = payload
    const result = await api.deployApi.addAdminBulletin({...payload, type: type || state.type})
    dispatch('getNewestNotice', {type: type || state.type})
    return result
  },
  // 编辑管理员公告
  async editAdminBulletin ({state, dispatch}, payload) {
    const {bulletinId, type} = payload
    const result = await api.deployApi.editAdminBulletin({...payload, type: type || state.type})
    dispatch('getHistoryNoticeList', {bulletinId, type: type || state.type})
    dispatch('getNewestNotice', {type: type || state.type})
    return result
  },
  // 删除管理员公告
  async deleteAdminBulletin ({state, dispatch}, payload) {
    const {type} = payload
    const result = await api.deployApi.deleteAdminBulletin({...payload, type: type || state.type})
    dispatch('getNewestNotice', {type: type || state.type})
    return result
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
